import { lazy } from 'react';

export const EpisodeListPage = lazy(() =>
  import('./episode-list.page').then((m) => ({ default: m.EpisodeListPage }))
);
